import { render, staticRenderFns } from "./AgroVisitaItem.vue?vue&type=template&id=d8becc64"
import script from "./AgroVisitaItem.vue?vue&type=script&lang=js"
export * from "./AgroVisitaItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports